import React, { Component, ComponentType, createContext, ReactNode } from 'react';
import { Omit } from 'react-router';

import { HeadMenuItem } from '@interfaces/head-menu';
import Vacancy from '@interfaces/vacancy';
import Settings from '@interfaces/settings';

export const AppData = createContext({});

interface ApplicationData {
    vacancies: Vacancy[];
    desktopVersionAlways: boolean;
    headMenu: HeadMenuItem[];
    settings: Settings;
    metrikaOptions: any;
}

export interface AppDataProps {
    appData: ApplicationData;
}

interface AppDataProviderProps {
    children: ReactNode;
    data: AppDataProps;
}

export class AppDataProvider extends Component<AppDataProviderProps> {
    public render() {
        const { data, children } = this.props;

        return (
            <AppData.Provider value={data}>
                {children}
            </AppData.Provider>
        );
    }
}

export function withAppData<P extends AppDataProps>(ComposedComponent: ComponentType<P>) {
    return class extends Component<Omit<P, keyof AppDataProps>> {
        public render() {
            return (
                <AppData.Consumer>
                    {(data: ApplicationData) =>
                        <ComposedComponent appData={data} {...this.props} />
                    }
                </AppData.Consumer>
            );
        }
    };
}
